<template>
  <layout-blank>

  </layout-blank>
</template>

<script>
import { LayoutBlank } from 'superv-js'

export default {
  name: 'Web',
  components: { LayoutBlank },
}
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
body {
  @apply bg-white;
  background-color:transparent !important;
}

.card-body {
  padding: 4px 8px !important;
  border: none !important;
}

.font-sans {
  font-size: 14px;
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.material-icons {
  font-size: 20px !important;
}
</style>
